import {Injectable} from '@angular/core';
import {Observable, from, of} from 'rxjs';
import {mergeMap, map, catchError} from 'rxjs/operators';
import {TileId, Tile} from '@shared/models/tile';
import {TileHistoryService} from '@core/services/tile-history.service';
import {TWO_MONTHS_MS} from '@shared/constants/tile-history.constants';

const REPLAY_CONCURRENCY = 10;

export interface ReplayTileResult {
  tileId: TileId;
  value: string | number | boolean | null;
  hasData: boolean;
}

@Injectable({providedIn: 'root'})
export class CanvasReplayService {
  constructor(private tileHistoryService: TileHistoryService) {}

  fetchReplayValues(
    tiles: {tileId: TileId; tile: Tile}[],
    timestamp: number
  ): Observable<ReplayTileResult> {
    const rangeEnd = new Date(timestamp).toISOString();
    const rangeStart = new Date(timestamp - TWO_MONTHS_MS).toISOString();

    return from(tiles).pipe(
      mergeMap(
        ({tileId, tile}) =>
          this.tileHistoryService
            .fetchHistory$(tile, 1, 'none', rangeStart, rangeEnd)
            .pipe(
              map(dataset => ({
                tileId,
                value: dataset.data?.[0]?.Value ?? null,
                hasData: !!(dataset.data?.length),
              })),
              catchError(() => of({tileId, value: null, hasData: false}))
            ),
        REPLAY_CONCURRENCY
      )
    );
  }
}
